import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { CouponService } from 'src/app/services/coupon.service';
import { UserService } from 'src/app/services/user.service';
import * as  _ from 'lodash';

@Component({
  selector: 'app-alternate-payment-modal',
  templateUrl: './alternate-payment-modal.component.html',
  styleUrls: ['./alternate-payment-modal.component.scss']
})
export class AlternatePaymentModalComponent {
  @Input() type: string[] = [];
  @Input() actualTypes: string[] = [];
  @Input() title: string = '';
  @Input() applyButton: string = '';

  @Input() chargeStr: string | null = null;
  @Input() patientPayable: any = 0;
  @Input() appliedPoints: any = null;
  @Input() parsedChargeInfo: any = null;
  @Input() computedDetail: any = null;
  @Input() selections: any = null;
  @Input() couponAdditionalParams: any = null;
  @Input() additionalInfo: any = null;
  @Input() isDiscountOnApptBooking: boolean = false;
  @Input() selectedServices: any = null;

  @Input() parentApplyingCode: boolean;
  @Input() apptDetail: any = null;
  @Input() chargeDetails: any = null;
  @Input() settings: {
    isEnableCoupon?: boolean;
    isEnablePromo?: boolean;
    isEnablePoints?: boolean;
  } | null = null;
  @Input() hidden: boolean = false;

  @Output() complete: EventEmitter<any>

  private loyaltyId: string | null = null;
  public healthPkg: any = null;

  public isFetchingPoints = false;
  public pointsInfo: any = null;
  public pointsAdded = 0;
  public pointsGuideline: string = '';
  public pointsDerivative: any = {};
  public availableNuhdeekPoints: number | null = null;
  public pointsChecked = false;
  public pointsAvailable: boolean = false;
  public pointsApplied = false;
  public pointsStatus: 'NONE' | 'SUCCESS' | 'FAILURE' = 'NONE';

  public promocodeApplied = false;
  public promocode: string = '';
  public maskedPromoCode: string = '';
  public promocodeChecked = false;
  public promocodeChecking = false;
  public promocodeStatus: 'NONE' | 'SUCCESS' | 'FAILURE' = 'NONE';

  private applicablePromoCode: any[] = [];
  private promoInfo: any[] = [];
  private appliedPromoDtls: any[] = [];
  private pendingAutoApplyPromoCode: string | null = null;

  public isFetchingCoupon = false;

  public couponDetails: {
    selectedCoupons: any[];
    couponList: any[];
    couponBalPatientPayable: number;
    isInValidCoupon: boolean;
    couponDiscount: number;
  } = {
    selectedCoupons: [],
    couponList: [],
    couponBalPatientPayable: 0,
    isInValidCoupon: false,
    couponDiscount: 0,
  };

  public showCouponAlert = true;
  public couponAlert = false;
  public isPackageCouponInc = true;
  public appliedPointsCpy: any = {};

  private localtyID: any;
  public appliedCoupons: any;
  public currency: any;
  public showNuhdeekPoints: boolean
  public skeletonArray = Array(25);
  constructor(private user: UserService, private cdf: ChangeDetectorRef, private couponService: CouponService) {
    // this.showCouponAlert = this.permission.canViewOption('SHOWCOUPONALERT')
    this.complete = new EventEmitter<any>()
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    //     const couponTypes = ['COUPON', 'COUPONNEW', 'VIEWONLY'];
    // const pointTypes = ['POINTS'];

    // const isCouponType = this.type?.some(t => couponTypes.includes(t));
    // const isPointsType = this.type?.some(t => pointTypes.includes(t));
    // if (isCouponType) {
    //   this.currency = this.user.getCurrency();
    //   this.couponDetails.couponBalPatientPayable = this.patientPayable
    //   this.localtyID = this.user.getloyaltyId();
    //   this.getPointsInfo()
    //   this.getPointsGuidelines()
    //   if (this.localtyID)
    //     this.getCouponDetails();
    // } else if (isPointsType) {
    //   this.currency = this.user.getCurrency();
    //   this.localtyID = this.user.getloyaltyId();
    //   this.getPointsInfo()
    //   this.getPointsGuidelines()
    // }

      if (this.additionalInfo?.remove) {
        console.log('additionalInfo 234', this.additionalInfo);
      if(this.appliedPoints && this.appliedPoints.pointsDerivative){
        this.appliedPointsCpy = _.cloneDeep(this.appliedPoints.pointsDerivative);
      }
      this.removeAppliedData(this.additionalInfo?.remove);
      return;
    }
    this.loyaltyId = this.user.getloyaltyId();
    this.getPointsGuidelines()
    if (this.type.includes('POINTS')) {
      this.getPointsInfo(false)
    }
    if (this.type.includes('PROMO')) {
      if (this.additionalInfo?.autoApply && this.additionalInfo?.promoCode) {
        this.pendingAutoApplyPromoCode = this.additionalInfo.promoCode;
      }
      if(!this.chargeDetails?.isPromoApplied || this.chargeDetails?.appliedpromocodedtls && this.chargeDetails?.appliedpromocodedtls.length ==0 ){
        this.resetPromo(true)
      } else if (this.pendingAutoApplyPromoCode) {
        this.getAvailablePromos();
      }
    }
    if (this.type.includes('COUPON')) {
      // Auto-apply logic for coupons
      if (this.additionalInfo?.autoApply) {
        this.couponDetails.couponBalPatientPayable = this.patientPayable
        this.getCouponDetails();
        return;
      }
      this.couponDetails.couponBalPatientPayable = this.computedDetail.discountedPayable
      this.getCouponDetails();
    }
    this.prefillDetails()
  }

  // private getPointsGuidelines() {
  //   const data = this.user.getUpdateInfoSync('directives');
  //   if (data) {
  //     let tc = data.userDefined.filter(def => {
  //       return def.directiveGroup == 'GUIDELINES'
  //     })
  //     if (tc) {
  //       let guidelines = [].concat.apply([], tc.map(t => t.concepts))
  //       console.log('guidelines', guidelines)
  //       let guideline = guidelines.find(c => c.code == 'POINTSGUIDELINES')
  //       console.log('guideline', guideline)
  //       if (guideline && guideline.detail) {
  //         this.pointsGuideline = guideline.detail;
  //       }
  //     }
  //   }
    
  // }
  // private getCouponDetails() {
  //   this.isFetchingCoupon = true;
  //   this.cdf.detectChanges()
  //   let payLoad: any = {
  //     loyaltyId: this.localtyID,
  //     isBackgroundProcess: true
  //   };
  //   this.couponService.getCoupons(payLoad).subscribe(res => {
  //     if (res['status'] == "SUCCESS") {
  //       let couponList = res.data;
  //       // couponList = coupons_mock;

  //       let selectedCouponsequence = []
  //       if (this.appliedCoupons && this.appliedCoupons.appliedcouponcodedtls && this.appliedCoupons.appliedcouponcodedtls.length > 0) {
  //         selectedCouponsequence = this.appliedCoupons.appliedcouponcodedtls.map(c => c.couponSequenceNo);
  //       }
  //       if (couponList && couponList.length > 0) {
  //         this.couponDetails.couponList = couponList.map(item => {
  //           item['loyaltyId'] = this.localtyID
  //           item.selected = selectedCouponsequence.indexOf(item.couponSequenceNo) > -1
  //           return item
  //         })
  //       }
  //     }
  //     this.isFetchingCoupon = false;
  //     console.log('couponDetails', this.couponDetails)
  //   }, err => {
  //     this.isFetchingCoupon = false;
  //   });
  // }

  // public goBack() {
  //   this.complete.emit({type: 'CLOSE'})
  // }

  // public selectCoupon(coupon) {
  //   if (this.type.includes('VIEWONLY')) return;
  //   if (this.couponDetails.couponBalPatientPayable == 0 && !coupon.selected) return;
  //   this.couponDetails.couponList.forEach(element => {
  //     if (element.couponSequenceNo == coupon.couponSequenceNo) {
  //       element.selected = !element.selected;
  //     }
  //   });
  //   this.checkCouponApplyStatus('MANUAL')
  // }

  // public checkCouponApplyStatus(event?) {
  //   console.log('checkCouponApplyStatus', event)
  //   this.couponDetails.selectedCoupons = []
  //   this.couponDetails.couponDiscount = this.couponDetails.couponList.reduce((discount, data, index) => {
  //     if (data.selected) {
  //       let couponDiscount = Number(data.cashDiscount)
  //       let balancePayable = Number(this.patientPayable) - discount
  //       let couponBurnt = 0;
  //       if (balancePayable > 0) {
  //         couponBurnt = Math.min(couponDiscount, balancePayable);
  //       }
  //       this.couponDetails.couponList[index]['couponBurnt'] = couponBurnt;
  //       discount += couponBurnt
  //       this.couponDetails.selectedCoupons.push(data)
  //     }
  //     return discount
  //   }, 0)
  //   if (this.showCouponAlert) {
  //     let totalCouponAmount = this.couponDetails.selectedCoupons.reduce((r, a) => {
  //       r += Number(a.cashDiscount)
  //       return r;
  //     }, 0)
  //     if (totalCouponAmount > Number(this.patientPayable)) {
  //       this.couponAlert = true;
  //     } else {
  //       this.couponAlert = false;
  //     }
  //   }
  //   this.couponDetails.couponBalPatientPayable = this.patientPayable - this.couponDetails.couponDiscount
  //   if (event == 'MANUAL') {
  //     this.couponDetails.couponList = _.cloneDeep(this.couponDetails.couponList)
  //   }
  //   console.log('couponDetails', this.couponDetails)
  // }

  // public apply() {
  //   const response = {
  //     appliedcouponcodedtls: this.couponDetails.selectedCoupons,
  //     value: this.couponDetails.couponDiscount
  //   }
  //   let payload = {
  //     data: response,
  //     type: 'COUPON',
  //   }
  //   this.complete.emit({type: 'APPLYCOUPON', payload: payload})
  // }

  // // public updatePointsDerivatives() {
  // //   console.log('updatePointsDerivatives')
  // //   let multiple = this.pointsInfo?.pointsMultiple;

  // //   let appliedPoints = this.pointsAdded || 0
  // //   let maxPoints = this.pointsInfo?.maxIncrement

  // //   let valid = appliedPoints <= maxPoints && (appliedPoints % (this.pointsInfo?.allowedMultiple || 1)) == 0
  // //   this.pointsDerivative = {
  // //     points: this.pointsAdded,
  // //     valid: valid,
  // //     loyaltyId: this.localtyID,
  // //     info: this.pointsInfo
  // //   }
  // //   // if (appliedPoints <= maxPoints) {
  // //   this.pointsDerivative.amount = this.user.fixDecimalPlaces(Number(this.pointsAdded) / multiple)
  // //   this.pointsDerivative.balance = this.user.fixDecimalPlaces(this.patientPayable - this.pointsDerivative.amount)
  // //   // }
  // //   console.log('updatePointsDerivatives', this.pointsDerivative)

  // // }

  // public updatePointsDerivatives() {
  //   let multiple = this.pointsInfo?.pointsMultiple;

  //   let appliedPoints = this.pointsAdded
  //   let maxPoints = this.pointsInfo?.maxIncrement
  //   let minPoints = this.pointsInfo?.minIncrement
      
  //   let valid = appliedPoints <= maxPoints && appliedPoints >= minPoints && (appliedPoints % (this.pointsInfo?.allowedMultiple || 1)) == 0
  //   this.pointsDerivative = {
  //     points: this.pointsAdded,
  //     valid: valid,
  //     loyaltyId: this.localtyID,
  //     info: this.pointsInfo
  //   }
  //   this.pointsDerivative.amount = this.user.fixDecimalPlaces(Number(this.pointsAdded) / multiple)
  //   let patientPayable = this.patientPayable;

  //   if (this.parsedChargeInfo && this.parsedChargeInfo.baseServiceAmount ) {
  //     patientPayable = parseFloat(this.parsedChargeInfo.baseServiceAmount) 
  //   }
  
  //   // Calculate VAT amount from base service amount and discounted points
  //   let baseServiceAmount = parseFloat(this.parsedChargeInfo.baseServiceAmount);
  //   let discountedPointsAmount = this.pointsDerivative.amount;
  //   let vatRate = this.parsedChargeInfo && this.parsedChargeInfo.vatDisplayAmount && parseFloat(this.parsedChargeInfo.vatDisplayAmount)>0 ? 15 : 0//parseFloat(this.parsedChargeInfo.vatRate) || 0;
  
  //   let vatAmount:any = this.user.fixDecimalPlaces((baseServiceAmount - discountedPointsAmount) * vatRate / 100);
  //   this.pointsDerivative.vatAmount = vatAmount;
  
  //   // Update balance
  //   this.pointsDerivative.balance = this.pointsDerivative.netservicecharge = this.user.fixDecimalPlaces(patientPayable - discountedPointsAmount) + vatAmount;

  //   console.info('pointsDerivative', this.pointsDerivative,this.pointsAdded,this.patientPayable,patientPayable,this.parsedChargeInfo,vatAmount)
  // }

  // private getPointsInfo() {
  //   this.isFetchingPoints = true;
  //   this.cdf.detectChanges()
  //   let payLoad: any = {
  //     loyaltyId: this.localtyID,
  //     patientPayable: this.patientPayable,
  //     isBackgroundProcess: true,
  //     chargeStr: this.discountDetails ? this.discountDetails.charge : ""
  //   };
  //   this.couponService.getPointsInfo(payLoad).subscribe(data => {
  //     this.pointsInfo = data
  //     if (this.appliedPoints && this.appliedPoints.pointsDerivative && this.appliedPoints.pointsDerivative.points) {
  //       this.pointsAdded = this.appliedPoints.pointsDerivative.points || 0
  //       this.updatePointsDerivatives()
  //     }
  //     if (this.pointsInfo?.minIncrement && this.pointsAdded < this.pointsInfo?.minIncrement) {
  //       this.pointsAdded = this.pointsInfo?.minIncrement
  //     }
  //     if(data && data.availablePoints !== null && data.availablePoints !== undefined) {
  //       this.pointsAvailable = true;
  //       this.availableNuhdeekPoints = data.availablePoints;
  //       if(data && data.expiryDetails && data.expiryDetails.value) {
  //         this.pointsDerivative = {
  //           expiry_points: data.expiryDetails.value
  //         }
  //       }
  //     }
  //     this.isFetchingPoints = false;
  //     this.cdf.detectChanges()
  //   }, err => {
  //     this.isFetchingPoints = false;
  //     this.cdf.detectChanges()
  //   })
  // }

  // public applyPoints() {
  //   const response = {
  //     pointsInfo: this.pointsInfo,
  //     pointsDerivative: this.pointsDerivative,
  //     netchargedtls: this.pointsInfo['netchargedtls']
  //   }
  //   let payload = {
  //     data: response,
  //     type: 'POINTS',
  //   }
  //   this.complete.emit({type: 'APPLYPOINTS', payload: payload})
  // }

    private removeAppliedData(remove) {
    console.log('removeAppliedData called with:', remove);
    if (remove.includes('POINTS')) {
      this.removeAllPoints(true)
    }
  }

  private prefillDetails() {
    if (this.apptDetail?.selectedDiscountDetails?.enteredPromoCode || this.chargeDetails?.appliedpromocodedtls && this.chargeDetails?.appliedpromocodedtls.length > 0) {
      this.promocode = this.apptDetail?.selectedDiscountDetails?.enteredPromoCode || this.chargeDetails?.appliedpromocodedtls[0]?.promocode;
      this.maskedPromoCode = this.mask(this.promocode, 2, 1)
      this.postValidateDiscount(this.apptDetail?.selectedDiscountDetails || this.chargeDetails)
    }
  }

  private getPointsGuidelines() {
    let tc = this.user.getDirectiveByDirectiveGroup('GUIDELINES');
    if (tc) {
      let guidelines = [].concat.apply([], tc.map(t => t.concepts))
      let guideline = guidelines.find(c => c.code == 'POINTSGUIDELINES')
      if (guideline && guideline.detail) {
        this.pointsGuideline = guideline.detail;
      }
    }
  }

  public onInputChange(value) {
    console.log('onInputChange', value);
  if (value.trim() === '') {
    this.promocodeApplied = false;
    this.removePromo();
  }
  }

  public goBack() {
    this.complete.emit({type: 'CLOSE'})
  }


  private getPointsInfo(getFamilyPoints: boolean) {
    this.isFetchingPoints = true;
    this.cdf.detectChanges()
    let payLoad: any = {
      loyaltyId: this.loyaltyId,
      patientPayable: this.patientPayable || null,
      isBackgroundProcess: true,
      mobileNo: this.user.getPersonMobile(),
      countryCode: this.user.getPersonCountryCode(),
      getFamilyPoints: getFamilyPoints,
      chargeStr: this.chargeStr
    };
    this.couponService.getPointsInfo(payLoad).subscribe(data => {
      this.pointsInfo = data
      if (this.appliedPoints && this.appliedPoints.pointsDerivative && this.appliedPoints.pointsDerivative.points) {
        this.pointsAdded = this.appliedPoints.pointsDerivative.points
      }
      if (this.pointsInfo?.minIncrement && this.pointsAdded < this.pointsInfo?.minIncrement) {
        this.pointsAdded = this.pointsInfo?.minIncrement
      }
      if (this.appliedPoints && this.appliedPoints.pointsDerivative && this.appliedPoints.pointsDerivative.points) {
        this.updatePointsDerivatives()
      }
      if (data && data.availablePoints !== null && data.availablePoints !== undefined) {
        this.pointsAvailable = true;
        this.availableNuhdeekPoints = data.availablePoints;
        if (data && data.expiryDetails && data.expiryDetails.value) {
          this.pointsDerivative = {
            expiry_points: data.expiryDetails.value
          }
        }
      }
      console.log('points info--',this.pointsAdded,this.pointsInfo,this.appliedPoints)
      this.isFetchingPoints = false;
      this.cdf.detectChanges()
    }, err => {
      this.isFetchingPoints = false;
      this.cdf.detectChanges()
    })
  }

  public updatePointsDerivatives() {
    console.log('updatePointsDerivatives', JSON.stringify(this.parsedChargeInfo))
    let multiple = this.pointsInfo?.pointsMultiple;

    let appliedPoints = this.pointsAdded
    let maxPoints = this.pointsInfo?.maxIncrement
    let minPoints = this.pointsInfo?.minIncrement

    let valid = appliedPoints <= maxPoints && appliedPoints >= minPoints && (appliedPoints % (this.pointsInfo?.allowedMultiple || 1)) == 0
    this.pointsDerivative = {
      points: this.pointsAdded,
      valid: valid,
      loyaltyId: this.loyaltyId,
      info: this.pointsInfo
    }
    this.pointsDerivative.amount = this.user.fixDecimalPlaces(Number(this.pointsAdded) / multiple)
    let patientPayable = this.patientPayable;

    if (this.parsedChargeInfo && this.parsedChargeInfo.baseServiceAmount) {
      patientPayable = parseFloat(this.parsedChargeInfo.baseServiceAmount)
    }

    // Calculate VAT amount from base service amount and discounted points
    let baseServiceAmount = parseFloat(this.parsedChargeInfo.baseServiceAmount);
    let discountedPointsAmount = this.pointsDerivative.amount;
    let vatRate = this.parsedChargeInfo && this.parsedChargeInfo.vatDisplayAmount && parseFloat(this.parsedChargeInfo.vatDisplayAmount) > 0 ? 15 : 0//parseFloat(this.parsedChargeInfo.vatRate) || 0;

    let vatAmount: any = this.user.fixDecimalPlaces((baseServiceAmount - discountedPointsAmount) * vatRate / 100);
    this.pointsDerivative.vatAmount = vatAmount;

    // Update balance
    this.pointsDerivative.balance = this.user.fixDecimalPlaces(patientPayable - discountedPointsAmount) + vatAmount;
    
    // Calculate computedDetail locally without API call
    this.calculateComputedDetailLocally();
  }

  public onInput(event) {
    this.promocodeChecked = false;
  }

  private calculateComputedDetailLocally() {
    console.log('calculateComputedDetailLocally', this.pointsDerivative,this.parsedChargeInfo)
    // Calculate computedDetail locally for points without API call
    if (this.pointsDerivative?.amount > 0) {
      // Update charge details with points discount
      this.chargeDetails['appliedPoints'] = this.pointsDerivative;
      this.chargeDetails['pointsDiscount'] = Number(this.pointsDerivative.amount || 0);
      this.chargeDetails['isPointsApplied'] = this.chargeDetails['pointsDiscount'] > 0;
      
      // Calculate discounted amounts
      let discount = this.chargeDetails['pointsDiscount'] || 0;
      this.chargeDetails['discountedCC'] = Number(this.parsedChargeInfo?.baseServiceAmount) - discount;
      
      // Calculate net payable with VAT
      let baseServiceAmount = parseFloat(this.parsedChargeInfo.baseServiceAmount);
      let discountedPointsAmount = this.pointsDerivative.amount;
      let vatRate = this.parsedChargeInfo && this.parsedChargeInfo.vatDisplayAmount && parseFloat(this.parsedChargeInfo.vatDisplayAmount) > 0 ? 15 : 0;
      let vatAmount = this.user.fixDecimalPlaces((baseServiceAmount - discountedPointsAmount) * vatRate / 100);
      console.log('vatAmount', baseServiceAmount,discountedPointsAmount,vatRate,vatAmount,this.user.fixDecimalPlaces((baseServiceAmount - discountedPointsAmount) + Number(vatAmount) + (this.chargeDetails?.['homeCareAdditionalCharge'] ? Number(this.chargeDetails?.['homeCareAdditionalCharge']) : 0)))
      
      this.pointsDerivative.netservicecharge = this.chargeDetails['netPayable'] = this.user.fixDecimalPlaces((baseServiceAmount - discountedPointsAmount) + Number(vatAmount) + (this.chargeDetails?.['homeCareAdditionalCharge'] ? Number(this.chargeDetails?.['homeCareAdditionalCharge']) : 0));
      this.chargeDetails['discountedPayable'] = this.chargeDetails['netPayable'];
      
      // Update VAT display amount
      this.parsedChargeInfo['vatAmount'] = vatAmount;
      this.parsedChargeInfo['vatDisplayAmount'] = this.calculateVatDisplayAmount(vatAmount, 0);
    }
    console.log('calculateComputedDetailLocally chargeDetails', this.chargeDetails,this.parsedChargeInfo,this.chargeDetails['netPayable'])
    // Recalculate computedDetail with updated charge details
     this.computedDetail = this.getComputedCodeDetail(true);
  }

  public applyPoints() {
    // Set appliedPoints for API validation
    const response = {
      pointsInfo: this.pointsInfo,
      pointsDerivative: this.pointsDerivative
    }
    this.appliedPoints = response;
    
    // Call API to validate points before final application
    this.recalculateVat('POINTS', true);
  }

  public checkPromoCode(autoApply: boolean = false) {
    this.maskedPromoCode = this.mask(this.promocode, 2, 1)
    this.promocodeStatus = 'NONE'
    this.promocodeChecking = true;
    this.recalculateVat('PROMO', autoApply)
  }

  private mask(value: string, start: number = 2, end: number = 1): string {
    const first = value.substring(0, start);
    const last = value.substring(value.length - end);

    const mask = value.substring(start, value.length - end).replace(/./g, "*");
    return first + mask + last;
  }

  public removePromo() {
    console.log('removePromo called - clearing promo data');
    this.resetPromo();
    this.removeAllCoupons()
    // Clear promo-related charge details immediately
    this.chargeDetails['appliedpromocodedtls'] = [];
    this.chargeDetails['promoDiscount'] = 0;
    this.chargeDetails['isPromoApplied'] = false;
    console.log('chargeDetails after promo removal:', this.chargeDetails);
    this.recalculateVat('REMOVE')
    // this.removeDiscounts()
  }

  private resetPromo(isInit:boolean = false) {
    this.promocode = ''
    this.maskedPromoCode = ''
    this.promocodeApplied = false
    this.promocodeChecked = false
    this.promocodeChecking = true
    this.promocodeStatus = 'NONE';
    this.applicablePromoCode = [];
    this.promoInfo = [];
    this.appliedPromoDtls = [];
    if(!isInit) this.apptDetail.selectedDiscountDetails = null;
    this.getAvailablePromos();
  }

  public removeAllPoints(autoApply: boolean = false) {
    this.pointsApplied = false;
    this.appliedPoints = {};
    this.apptDetail.selectedDiscountDetails = null
    this.recalculateVat('REMOVE', autoApply)
  }

  private getAvailablePromos() {
    let payLoad: any = {
      applyDiscountYn: "N",
      chargeStr: this.chargeStr || '',
      facilityId: this.selections['selectedFacility'] && this.selections['selectedFacility']['facilityId'] ? this.selections['selectedFacility']['facilityId'] : "",
      patientId: this.selections['selectedPatient'] && this.selections['selectedPatient']['patientId'] ? this.selections['selectedPatient']['patientId'] : "",
      practitionerId: this.selections['selectedPractitioner'] ? this.selections['selectedPractitioner'] : "",
      specialityId: this.selections['selectedSpeciality'] ? this.selections['selectedSpeciality'] : "",
      selectedServices:  this.selectedServices ?? null,
      isBackgroundProcess: true
    }
    this.couponService.getPromo(payLoad).subscribe(res => {
      this.promocodeChecking = false;
      if (res['status'] == "SUCCESS") {
        this.applicablePromoCode = res['data']['applicablepromocodedtls'];
        this.promoInfo = res['data']['promoInfo'];
        this.appliedPromoDtls = res['data']['appliedpromocodedtls']
      }
      if (this.pendingAutoApplyPromoCode) {
        const code = this.pendingAutoApplyPromoCode;
        this.pendingAutoApplyPromoCode = null;
        this.autoApplyPromoCode(code);
      }
    }, err => {
      this.promocodeChecking = false;
      this.pendingAutoApplyPromoCode = null;
    });
  }

  public apply() {
    console.log('apply', this.computedDetail, this.apptDetail, this.chargeDetails)
    //this.appointmentService.setAltPaymentSubject({ computedDetail: this.computedDetail, apptDetail: this.apptDetail, chargeDetails: this.chargeDetails })
    //this.modalCtrl.dismiss({ computedDetail: this.computedDetail, apptDetail: this.apptDetail, chargeDetails: this.chargeDetails })

    // If points are applied, validate with API before applying
    if (this.pointsDerivative?.amount > 0) {
      this.applyPoints();
    } else {
      //this.appointmentService.setAltPaymentSubject({ computedDetail: this.computedDetail, apptDetail: this.apptDetail, chargeDetails: this.chargeDetails })
      this.complete.emit({ computedDetail: this.computedDetail, apptDetail: this.apptDetail, chargeDetails: this.chargeDetails })
    }
  }

  private recalculateVat(type: 'POINTS' | 'PROMO' | 'REMOVE' | any, autoApply: boolean = false) {
    // Handle wellness coupon parameter
    if (typeof type === 'object' && type.wellnessCouponInfo) {
      // This is a wellness coupon object, not a type string
      this.postrecalculateVatForWellnessCoupon(type, autoApply);
      return;
    }
    console.log('recalculateVat', this.promocode, this.pointsDerivative, this.chargeDetails, this.couponDetails?.selectedCoupons,this.appliedPointsCpy)
    // Original logic for type-based recalculation
    if ((this.promocode || this.pointsDerivative?.points || this.chargeDetails?.appliedPoints || this.appliedPointsCpy?.points) && (this.couponDetails?.selectedCoupons?.length > 0 || this.chargeDetails?.appliedcouponcodedtls?.length > 0)) {
      this.appliedPointsCpy = {}
      this.removeAllCoupons(true,type,autoApply)
    }else
      this.postrecalculateVat(type, autoApply)
  }

  private removeAllCoupons(fromPromo?: boolean,type?:any,autoApply?:boolean) {
    console.log('removeAllCoupons', this.chargeDetails)
    // remove all coupons from couponDetails
    let chargeDetailsCoupons = this.chargeDetails?.appliedcouponcodedtls || [];
    let chargeDetailsCouponNumbers = chargeDetailsCoupons.map(c => c.couponSequenceNo); 
    
    this.couponDetails.couponList.forEach(c => {
        c.selected = false;
    });
    this.couponDetails.selectedCoupons = [];
    this.couponDetails.couponDiscount = 0;
    // Recalculate selected coupons and discounts based on current selections
    this.checkCouponApplyStatus();
    
    if (fromPromo) {
      this.showReselectCouponModal(type,autoApply);
    }
  }

  private postrecalculateVatForWellnessCoupon(wellnessCoupon: any, autoApply: boolean = false) {
    console.log('postrecalculateVatForWellnessCoupon', wellnessCoupon,autoApply);
    
    const payload = {
      applicablePromoCodeDtls: null,
      practitionerId: this.selections?.selectedPractitioner || "",
      facilityId: this.selections?.selectedFacility?.facilityId || "",
      serviceCharge: this.patientPayable,
      netServiceCharge: this.patientPayable,
      cartValue: this.patientPayable,
      promoInfo: null,
      appliedPromoCodeDtls: null,
      applyDiscountYn: "Y",
      selectedPromoCodes: null,
      patientId: this.selections?.selectedPatient?.patientId || "",
      selectedServices: this.selectedServices ? this.selectedServices : null,
      chargeStr: this.chargeStr || "",
      specialityId: this.selections?.selectedSpeciality || "",
      wellnessCouponInfo: wellnessCoupon?.wellnessCouponInfo,
      isBackgroundProcess: true,
      isToastBlock: true
    }
    
    this.couponService.validatePromoCode(payload).subscribe(res => {
      if (res['STATUS'] == "SUCCESS") {
        if (res?.data) {
          // Update the computed detail with wellness discount info
          this.postValidateDiscount(res.data)
        }
        this.applyCouponDirectly(autoApply);
      }
    }, (err) => {
      console.error('Wellness coupon validation failed:', err);
      this.applyCouponDirectly();
    })
  }

  private updateWellnessDiscountInfo(data: any) {
    // Update charge details with wellness discount information
    if (data.netservicecharge != null) {
      this.chargeDetails.netPayable = Number(data.netservicecharge);
      this.chargeDetails.discountedPayable = Number(data.netservicecharge);
    }
    
    // Update VAT information if available
    if (data.netchargedtls && data.netchargedtls.length > 0) {
      this.parsedChargeInfo['vatAmount'] = data.netchargedtls[0].taxAmount;
      this.parsedChargeInfo['vatExemptAmount'] = data.netchargedtls[0].taxExemptAmount;
      this.parsedChargeInfo['vatDisplayAmount'] = this.calculateVatDisplayAmount(
        data.netchargedtls[0].taxAmount, 
        data.netchargedtls[0].taxExemptAmount
      );
    }
  }

  private postrecalculateVat(type: 'POINTS' | 'PROMO' | 'REMOVE', autoApply) {
    if (!this.promocode && !this.appliedPoints?.pointsDerivative?.amount) {
      // When removing discounts, we still need to recalculate VAT display amount
      if (type === 'REMOVE') {
        this.recalculateVatDisplayAmountForRemoval();
      }
      this.calculatePayable(autoApply)
      return;
    }
    const payload = {
      //unused
      applicablePromoCodeDtls: this.applicablePromoCode?.length ? this.applicablePromoCode : null,
      practitionerId: this.selections['selectedPractitioner'] ? this.selections['selectedPractitioner'] : "",
      //for validating and recalculating VAT
      facilityId: this.selections['selectedFacility'] && this.selections['selectedFacility']['facilityId'] ? this.selections['selectedFacility']['facilityId'] : "",
      serviceCharge: this.patientPayable,
      netServiceCharge: this.patientPayable,
      cartValue: this.patientPayable,
      promoInfo: this.promoInfo,
      appliedPromoCodeDtls: this.appliedPromoDtls,
      applyDiscountYn: "Y",
      selectedPromoCodes: this.promocode,
      patientId: this.selections['selectedPatient'] && this.selections['selectedPatient']['patientId'] ? this.selections['selectedPatient']['patientId'] : "",
      selectedServices: this.selectedServices ?? null,
      chargeStr: this.chargeStr,
      specialityId: this.selections['selectedSpeciality'] ? this.selections['selectedSpeciality'] : "",
      //new attributes
      appliedPoints: this.appliedPoints,
    }
    this.couponService.validatePromoCode(payload).subscribe(res => {
      if (res['STATUS'] == "SUCCESS") {
        res.data.enteredPromoCode = this.promocode;
        this.postValidateDiscount(res.data)
        this.promocodeChecking = false;
      }
      this.calculatePayable(autoApply)
    }, (err) => {
      this.promocodeChecking = false;
    })
  }

  private postValidateDiscount(data) {
    if (this.promocode) {
      this.promocodeChecked = true;
      if (data?.appliedpromocodedtls?.length > 0) {
        this.promocodeApplied = true;
        this.promocodeStatus = 'SUCCESS'
      } else {
        this.promocodeApplied = false;
        this.promocodeStatus = 'FAILURE';
        this.promocodeChecked = false;
      }
    }
    if (this.appliedPoints?.pointsDerivative?.amount > 0) {
      this.pointsChecked = true;
      if (data?.pointsApplied?.amount > 0) {
        this.pointsApplied = true;
        this.pointsStatus = 'SUCCESS'
      } else {
        this.pointsApplied = false;
        this.pointsStatus = 'FAILURE'
        this.removeAllPoints()
      }
    }

    if (data.netservicecharge != null) {
      data.pointsDerivative = data.pointsApplied
      data.appliedPoints = _.cloneDeep(this.appliedPoints)
      delete data.pointsApplied;
      this.apptDetail.selectedDiscountDetails = data;
    }
    this.promocodeChecking = false
    if(data.netchargedtls && data.netchargedtls.length > 0){
        this.calculateVatcharges(data.netchargedtls)
    }
    this.parsedChargeInfo['vatDisplayAmount'] = this.calculateVatDisplayAmount(
      data.vatAmount, 
      data.vTaxExemptAmount
    );
  }
  private calculateVatcharges(parsedCharges){
		let baseAmount=0,vatAmount=0,vatExemptAmount=0;
		parsedCharges.forEach(charge => {
			baseAmount= baseAmount+ parseFloat(charge.baseServiceAmount);
			vatAmount= vatAmount+ (charge.vatAmount? parseFloat(charge.vatAmount) : (charge.taxAmount ? parseFloat(charge.taxAmount) : 0));
			vatExemptAmount= vatExemptAmount+ (charge.vatExemptedAmt ? parseFloat(charge.vatExemptedAmt): (charge.taxExemptAmount ? parseFloat(charge.taxExemptAmount) : 0));
		})
    this.parsedChargeInfo['vatAmount'] = this.user.fixDecimalPlaces(vatAmount);
    this.parsedChargeInfo['vatExemptAmount'] = this.user.fixDecimalPlaces(vatExemptAmount);
		this.parsedChargeInfo['vatDisplayAmount']=this.calculateVatDisplayAmount(this.parsedChargeInfo.vatAmount,this.parsedChargeInfo.vatExemptAmount);
		console.log("this.chargeVatDetails", this.parsedChargeInfo)
	}

  private getCouponDetails() {
    this.isFetchingCoupon = true;
    this.cdf.detectChanges()
    let packageInfo = null;
    if (this.couponAdditionalParams?.package) {
      packageInfo = {
        code: this.couponAdditionalParams.package.code,
        chargeStr: this.couponAdditionalParams.package.chargeStr,
        directiveCode: this.couponAdditionalParams.package._directiveRef?.code,
        directiveGroup: this.couponAdditionalParams.package._directiveRef?.directiveGroup,
        patientId: this.couponAdditionalParams.patient?.uhid,
        mobileNo: this.user.getPersonMobile(),
        countryCode: this.user.getPersonCountryCode()
      }
    }
    let payLoad: any = {
      loyaltyId: this.loyaltyId,
      isBackgroundProcess: true,
      isPackage: this.couponAdditionalParams?.isPackage || false,
      package: packageInfo,
      source: 'COUPONNEW'
    };
    let selectedCoupons = this.chargeDetails?.appliedcouponcodedtls || [];
    let couponNumbers = selectedCoupons.map(c => c.couponSequenceNo);
    this.couponService.getCoupons(payLoad).subscribe(res => {
      if (res['status'] == "SUCCESS") {
        let couponList = res.data;
        if (couponList && couponList.length > 0) {
          this.couponDetails.couponList = couponList.map(item => {
            item.loyaltyId = this.loyaltyId
            if (couponNumbers.includes(item.couponSequenceNo)) item.selected = true
            return item
          })
          console.log('couponList',this.couponDetails.couponList,this.computedDetail)
          if (this.additionalInfo?.autoApply) {
            this.chooseCouponForAutoApply()
          }
        } else {
          this.postFetchCoupon()
        }
      } else {
        this.postFetchCoupon()
      }
      this.isFetchingCoupon = false;
    }, err => {
      this.isFetchingCoupon = false;
      this.postFetchCoupon(err)
    });
  }

  private postFetchCoupon(err = null) {
    if (err?.errorInfo?.showModal) {
      this.showCouponError(err)
    }
    this.checkCouponApplyStatus()
    // Auto-apply logic
    if (this.additionalInfo?.autoApply) {
      this.calculatePayable(true);
    }
  }

  private async showCouponError(err) {
    // const modal = await this.modalCtrl.create({
    //   component: InsuranceModalComponent,
    //   swipeToClose: false,
    //   showBackdrop: true,
    //   backdropDismiss: true,
    //   mode: 'ios',
    //   cssClass: 'modal-class',
    //   componentProps: { showButtons: false, policyDetails: null, type: 'FETCHCOUPONERROR', errorInfo: err.errorInfo.data }
    // });
    // modal.onDidDismiss().then(({ data }) => {

    // }).catch(_ => { });
    // return await modal.present();
  }

  public selectCoupon(coupon) {
    console.log('select coupon 1',this.couponDetails,coupon)
    this.patientPayable = this.computedDetail?.display?.discountedPayable;
    const isWellnessCoupon = this.couponAdditionalParams?.package?.code && coupon.wellnessCouponInfo?.code === this.couponAdditionalParams.package.code
    if (this.couponDetails.couponBalPatientPayable == 0 && !coupon.selected) return;
    this.couponDetails.couponList.forEach(element => {
      if (element.couponSequenceNo == coupon.couponSequenceNo) {
        element.selected = !element.selected;
        if (isWellnessCoupon) {
          element.isWellnessCoupon = true
        } else {
          delete element.isWellnessCoupon
        }
      } else if (isWellnessCoupon) {
        element.selected = false
      }
    });
    console.log('selectCoupon', coupon, 'isWellnessCoupon', isWellnessCoupon)
    this.checkCouponApplyStatus('MANUAL', isWellnessCoupon)
  }

  public checkCouponApplyStatus(event: any = null, isWellnessCoupon: boolean = false) {
    this.couponDetails.selectedCoupons = []
    this.couponDetails.couponDiscount = this.couponDetails.couponList.reduce((discount, data, index) => {
      // console.log('coupon appleding data', data,discount,index,this.patientPayable)
      if (data.selected) {
        let couponDiscount = Number(data.cashDiscount)
        let balancePayable = Number(this.patientPayable) - discount
        let couponBurnt = 0;
        console.log('balancePayable', balancePayable,couponDiscount,this.patientPayable)
        if (balancePayable > 0) {
          couponBurnt = Math.min(couponDiscount, balancePayable);
        }
        this.couponDetails.couponList[index]['couponBurnt'] = couponBurnt;
        discount += couponBurnt
        this.couponDetails.selectedCoupons.push(data)
      }
      return discount
    }, 0)
    if (this.showCouponAlert) {
      let totalCouponAmount = this.couponDetails.selectedCoupons.reduce((r, a) => {
        r += Number(a.cashDiscount)
        return r;
      }, 0)
      if (totalCouponAmount > Number(this.patientPayable)) {
        this.couponAlert = true;
      } else {
        this.couponAlert = false;
      }
    }
    console.log('coupon info',this.couponDetails,this.computedDetail,this.computedDetail.discountedPayable - this.couponDetails.couponDiscount)
    this.couponDetails.couponBalPatientPayable = this.computedDetail.discountedPayable - this.couponDetails.couponDiscount
    if (event == 'MANUAL') {
      this.couponDetails.couponList = _.cloneDeep(this.couponDetails.couponList)
    }
    
    // Use common method to handle both wellness and regular coupons
    this.handleCouponApplication(isWellnessCoupon);
  }

  private handleCouponApplication(isWellnessCoupon: boolean = false) {
    console.log('handleCouponApplication', isWellnessCoupon, this.couponDetails.selectedCoupons);
    
    if (isWellnessCoupon) {
      // For wellness coupons, check if there's a wellness coupon selected
      let wellnessCoupon = this.couponDetails.selectedCoupons.find(c => 
        this.couponAdditionalParams?.package?.code && 
        c.wellnessCouponInfo?.code === this.couponAdditionalParams.package.code
      );
      console.log('wellnessCoupon in handleCouponApplication',wellnessCoupon)
      if (wellnessCoupon && Number(wellnessCoupon?.wellnessCouponInfo?.discount) > 0) {
        // Wellness coupon with discount - go through API validation
        this.recalculateVat(wellnessCoupon,isWellnessCoupon);
      } else {
        this.chargeDetails.discountedPayable = Number(this.chargeDetails.totalAmount);
        this.chargeDetails.netPayable = Number(this.chargeDetails.totalAmount);
        this.apptDetail.selectedDiscountDetails = null;
        this.parsedChargeInfo['vatDisplayAmount'] = this.calculateVatDisplayAmount(
          this.parsedChargeInfo.vatAmount, 
          this.parsedChargeInfo.vatExemptAmount
        );
        console.log('chargeDetails in handleCouponApplication remove coupon',this.chargeDetails)

        // No wellness coupon or no discount - apply directly
        // this.postrecalculateVat('REMOVE', false)
        this.applyCouponDirectly(isWellnessCoupon);
      }
    } else {
      // Regular coupon - apply directly
      this.applyCouponDirectly();
    }
  }

  private applyCouponDirectly(isWellnessCoupon?) {
    console.log('applyCouponDirectly',isWellnessCoupon);
    this.updateCouponDetails();
    this.calculatePayable(isWellnessCoupon);
  }

  private calculatePayable(autoApply: boolean = false) {
    if(this.isDiscountOnApptBooking) {
      this.computedDetail = this.getComputedCodeDetail()
    } else
      this.computedDetail = this.user.computeCostForAppt(this.selections, this.chargeDetails);
    let couponDiscount = Number(this.couponDetails?.couponDiscount || 0)
    this.couponDetails.couponBalPatientPayable = this.computedDetail.discountedPayable - couponDiscount;
    if (autoApply) {
      setTimeout(_ => {
        //this.apply()
        // Dismiss modal with final validated data
        this.complete.emit({ computedDetail: this.computedDetail, apptDetail: this.apptDetail, chargeDetails: this.chargeDetails })
      }, 500)
    }
  }

  private updateCouponDetails() {
    const response = {
      appliedcouponcodedtls: this.couponDetails.selectedCoupons,
      value: this.couponDetails.couponDiscount,
      additionalDiscount: null
    }
    this.apptDetail.couponDetails = response
  }

  // openAlphaNumKeyboard(ev = null) {
  //   this.user.openAlphaNumKeyboard(ev, true);
  // }

  public getComputedCodeDetail(manualApply: boolean = false) {
    let discountDetails = this.apptDetail?.selectedDiscountDetails
    if (manualApply) {
      discountDetails = {pointsDerivative: this.pointsDerivative}
    }
    const couponDetails = this.apptDetail?.couponDetails
    let vatAmount = this.parsedChargeInfo?.vatAmount
    console.log('discountDetails', discountDetails, 'couponDetails', couponDetails, ' this.apptDetail',  this.apptDetail);
    console.log('this.chargeDetails', this.chargeDetails)
    const calculated: any = {
      netPayable: this.chargeDetails.netPayable,
      discountedPayable: this.chargeDetails?.discountedPayable
    }

    if (discountDetails?.appliedpromocodedtls?.length > 0 || discountDetails?.pointsDerivative?.amount || discountDetails?.appliedDiscount) {
      if (discountDetails?.appliedpromocodedtls?.length) {
        // Promo
        calculated.appliedpromocodedtls = this.chargeDetails['appliedpromocodedtls'] = discountDetails?.appliedpromocodedtls || null;
        calculated.promoDiscount = this.chargeDetails['promoDiscount'] = Number(discountDetails?.calculatedDiscountAmt || 0);
        calculated.isPromoApplied = this.chargeDetails['isPromoApplied'] = discountDetails?.appliedpromocodedtls?.length > 0;
      } else if (discountDetails?.pointsDerivative?.amount) {
        // Points
        calculated.appliedPoints = this.chargeDetails['appliedPoints'] = discountDetails?.pointsDerivative || null;
        calculated.pointsDiscount = this.chargeDetails['pointsDiscount'] = Number(discountDetails?.pointsDerivative?.amount || 0);
        calculated.isPointsApplied = this.chargeDetails['isPointsApplied'] = calculated.pointsDiscount > 0
      } else if (discountDetails.appliedDiscount) {
        this.chargeDetails.generalDiscount = calculated.generalDiscount = Number(discountDetails.calculatedDiscountAmt);
        this.chargeDetails.isGeneralDiscountApplied = calculated.isGeneralDiscountApplied = this.chargeDetails.generalDiscount > 0
        this.chargeDetails.generalDiscountDetails = calculated.generalDiscountDetails = { services: discountDetails.appliedDiscount }
      }

      //Discount
      let discount = calculated.promoDiscount || calculated.pointsDiscount || calculated.generalDiscount || 0
      if(manualApply){
        calculated.discountedCC = this.chargeDetails['discountedCC']
        calculated.netPayable = this.chargeDetails['netPayable']
        calculated.discountedPayable = this.chargeDetails['discountedPayable']
      } else {
        calculated.discountedCC = this.chargeDetails['discountedCC'] = Number(this.parsedChargeInfo?.baseServiceAmount) - discount
        calculated.netPayable = this.chargeDetails['netPayable'] = this.user.fixDecimalPlaces(Number(discountDetails?.netservicecharge) + (this.chargeDetails?.['homeCareAdditionalCharge']? Number(this.chargeDetails?.['homeCareAdditionalCharge']) :0))
        calculated.discountedPayable = this.chargeDetails['discountedPayable'] = this.user.fixDecimalPlaces(Number(discountDetails?.netservicecharge) + (this.chargeDetails?.['homeCareAdditionalCharge']? Number(this.chargeDetails?.['homeCareAdditionalCharge']) :0))
      }
      vatAmount = this.user.fixDecimalPlaces(Number(discountDetails?.vatAmount))
      //this.chargeDetails['totalVat'] = discountDetails?.vatAmount
      //this.chargeDetails['vatExemptAmount'] = vatExemptAmount = Number(discountDetails?.vatExemptAmount)
    } else {
      // No discounts applied - reset to original values
      console.log('Removing all discounts, resetting to totalAmount:', this.chargeDetails['totalAmount']);
      this.chargeDetails['appliedpromocodedtls'] = [];
      this.chargeDetails['promoDiscount'] = 0;
      this.chargeDetails['isPromoApplied'] = false;
      this.chargeDetails['appliedPoints'] = null;
      this.chargeDetails['pointsDiscount'] = 0;
      this.chargeDetails['isPointsApplied'] = false;
      this.chargeDetails.generalDiscount = 0;
      this.chargeDetails.isGeneralDiscountApplied = false;
      this.chargeDetails.generalDiscountDetails = null;
      calculated.netPayable = this.chargeDetails['netPayable'] = this.chargeDetails['totalAmount']
      calculated.discountedPayable = this.chargeDetails['discountedPayable'] = this.chargeDetails['totalAmount']
      console.log('Updated netPayable to:', this.chargeDetails['netPayable']);
    }
    // Coupon
    if (couponDetails?.appliedcouponcodedtls.length > 0) {
      calculated.appliedcouponcodedtls = this.chargeDetails['appliedcouponcodedtls'] = couponDetails.appliedcouponcodedtls;
      calculated.couponTitle = this.chargeDetails['couponTitle'] = calculated.appliedcouponcodedtls.map(item => item.couponTitle)
      calculated.couponDiscount = this.chargeDetails['couponDiscount'] = Number(couponDetails.value);
      calculated.isCouponApplied = this.chargeDetails['isCouponApplied'] = couponDetails.appliedcouponcodedtls.length > 0;
      let couponDiscount = this.chargeDetails['couponDiscount'] = calculated.couponDiscount || 0;
      calculated.netPayable = this.chargeDetails['netPayable'] =  calculated?.discountedPayable - couponDiscount;
    } else {
      this.chargeDetails['couponDiscount'] = 0;
      this.chargeDetails['appliedcouponcodedtls'] = [];
      this.chargeDetails['isCouponApplied'] = false;
      // this.chargeDetails['discountedPayable'] = this.chargeDetails['totalAmount'];
      // this.chargeDetails['netPayable'] = this.chargeDetails['totalAmount'];
      this.chargeDetails['discountedCC'] = 0;
      this.chargeDetails['couponTitle'] = [];
    }

    let data = {
      loading: false,
      charge: this.chargeDetails.netPayable,
      patientPayable: this.chargeDetails.netPayable,
      discountedPayable: this.chargeDetails?.discountedPayable,
      freeFollowUp: this.chargeDetails?.isFreeFollowUp ? 'Y' : 'N',
      billingGroupCode: 'CASH',
      paid: false,
      additionalchargeDetail: {
          actualCharge: this.chargeDetails?.['consultationFee'],
          totalCharge: this.chargeDetails?.['totalAmount'],
          payableCharge: this.chargeDetails?.['netPayable'],
          homeCareAdditionalCharge: this.chargeDetails?.['homeCareAdditionalCharge']
      },
      promoDetails: this.chargeDetails?.discountDetails,
      promoCodeParams: this.selections,
      chargeVatDetails: this.parsedChargeInfo,
      coupon_or_discount: calculated,
      coupon: calculated?.appliedcouponcodedtls,
      isPromoApplied: calculated.isPromoApplied || false,
      isPointsApplied: calculated.isPointsApplied || false,
      isCouponApplied: calculated.isCouponApplied || false,
      display: {
        cc: this.parsedChargeInfo.baseServiceAmount,
        totalAmount: this.chargeDetails.netPayable,
        vat: this.parsedChargeInfo['vatDisplayAmount'] ? this.parsedChargeInfo['vatDisplayAmount'] : this.chargeDetails?.vatExemptAmount  ? 0 : vatAmount,
        promo: calculated.promoDiscount || 0,
        points: calculated.pointsDiscount || 0,
        coupon: calculated.couponDiscount || 0,
        discountedCC: calculated.discountedCC,
        discountApplied: (calculated.promoDiscount || calculated.pointsDiscount)  ? 'Y':  'N',
        discountedPayable: Number(calculated.discountedPayable),
        payable: calculated.netPayable,
        homeCareAdditionalCharge: this.chargeDetails?.['homeCareAdditionalCharge']
      },
    }
    if(this.chargeDetails?.totalVat){
      this.chargeDetails.totalVat = this.parsedChargeInfo['vatDisplayAmount'] ? this.parsedChargeInfo['vatDisplayAmount'] : this.chargeDetails?.vatExemptAmount  ? 0 : vatAmount
    }
    console.log('computedDetail',data);
    console.log('this.chargeDetails', this.chargeDetails)
    // this.healthPkgService.setValue('apptDetail', _.cloneDeep(this.apptDetail));
    // this.healthPkgService.setValue('computedDetail', _.cloneDeep(data));
    return data;

  }

  public removeDiscounts() {
    // this.isApplyingCode = true;
    this.chargeDetails.netPayable = Number(this.chargeDetails.totalAmount)
    this.chargeDetails.discountedPayable = Number(this.chargeDetails.totalAmount)
    this.chargeDetails.isPromoApplied = false;
    this.chargeDetails.promoDiscount = 0;
    this.removeAllPoints()
    this.handlePostDiscount()
  }

  private removeGeneralDiscount() {
    this.chargeDetails.generalDiscount = 0;
    this.chargeDetails.isGeneralDiscountApplied = false;
    this.chargeDetails.generalDiscountDetails = null;
  }

  private handlePostDiscount() {
    let isCouponHandled = this.chargeDetails.isCouponApplied
    let isPointsHandled = this.chargeDetails.isPointsApplied 

    if (isCouponHandled || isPointsHandled) {
      if (isCouponHandled) this.removeAllCoupons();
      if (isPointsHandled) this.removeAllPoints(!isCouponHandled);
    } else {
      this.calculatePayable()
    }
  }



  private calculateVatDisplayAmount(vatamt, vatexpamt) {
    let vatAmount, vatExemptedAmt, vatDisplayAmount;
    vatAmount = (vatamt && vatamt != '') ? parseFloat(vatamt) : 0;
    vatExemptedAmt = (vatexpamt && vatexpamt != '') ? parseFloat(vatexpamt) : 0;
    vatDisplayAmount = vatAmount - vatExemptedAmt;
    vatDisplayAmount = vatDisplayAmount.toString();
    return vatDisplayAmount;
  }

  private recalculateVatDisplayAmountForRemoval() {
    console.log('Recalculating VAT display amount after discount removal');
    // When discounts are removed, reset VAT display amount to original values
    if (this.chargeDetails?.vatAmount !== undefined && this.chargeDetails?.vatExemptAmount !== undefined) {
      // Use chargeDetails VAT info if available
      this.parsedChargeInfo['vatDisplayAmount'] = this.calculateVatDisplayAmount(
        this.chargeDetails.vatAmount, 
        this.chargeDetails.vatExemptAmount
      );
    } else if (this.parsedChargeInfo?.vatAmount !== undefined) {
      const originalVatExempt = this.parsedChargeInfo?.vatExemptAmount ?? this.parsedChargeInfo?.vatExemptedAmt ?? 0;
      this.parsedChargeInfo['vatDisplayAmount'] = this.calculateVatDisplayAmount(
        this.parsedChargeInfo.vatAmount,
        originalVatExempt
      );
    }
    console.log('Updated VAT display amount to:', this.parsedChargeInfo['vatDisplayAmount']);
  }

  private chooseCouponForAutoApply() {
    try {
      let coupon = this.couponDetails.couponList.find(c => {
        return c.wellnessCouponInfo?.code === this.couponAdditionalParams.package.code
      })
      if (coupon) {
        this.selectCoupon(coupon);
      } else {
        this.postFetchCoupon();
      }
    } catch (error) {
      this.postFetchCoupon();
    }
  }

  public autoApplyPromoCode(code: string) {
    this.promocode = code;
    this.checkPromoCode(true);
  }

  public clearPromoInput() {
    this.promocode = '';
    this.promocodeApplied = false;
    this.promocodeChecked = false;
    this.promocodeStatus = 'NONE';
    this.onInputChange('');
  }

  private async showReselectCouponModal(type?:any,autoApply?:boolean) {
    // try {
    //   const modal = await this.modalCtrl.create({
    //     component: CouponModalComponent,
    //     swipeToClose: true,
    //     showBackdrop: true,
    //     backdropDismiss: true,
    //     mode: "ios",
    //     cssClass: "modal-class",
    //     componentProps: {
    //       type: "RESELECT",
    //     },
    //   });
    //   modal.present();
    //   modal.onDidDismiss().then((data) => {
    //     console.log('showReselectCouponModal', data)
    //     this.postrecalculateVat(type, autoApply)
    //   })
    // } catch (e) {}
  }
}
